import { css } from '@emotion/react';
import { Modal } from 'antd';
import { useRouter } from 'next/router';
import React from 'react';
import { connect } from 'react-redux';

import { auth0DatabaseClient } from '@/src/auth/utils';
import Button from '@/src/shared/components/Button';
import buttonStyle from '@/src/shared/components/Button/style';

import HeaderSection from '../HeaderSection';
import StickyFooter from '../StickyFooter';

const styles = {
  changePasswordContainer: css`
    padding: 2.4rem 2.6rem 0 2.6rem;
  `,
  text: css`
    font-size: 1.6rem;
    margin-bottom: 0px;
  `,
};

const ChangePasswordForm = props => {
  const { form, user } = props;
  const { query } = useRouter();
  const router = useRouter();
  const fp = query.fp === 'Y';

  const sendEmail = email => {
    auth0DatabaseClient.changePassword(
      {
        email,
        connection: process.env.AUTH0_DATABASE,
      },
      (err, resp) => {
        if (err) {
          console.log(err);
        } else {
          router.push('/account/change-password/submission-confirmation/');
        }
      }
    );
  };

  const submit = e => {
    if (e && 'preventDefault' in e) e.preventDefault();
    Modal.confirm({
      title: 'Are you sure you want to reset your password?',
      keyboard: true,
      okText: 'Yes',
      cancelText: 'Cancel',
      cancelButtonProps: { css: [buttonStyle.size.small, buttonStyle.type.gray] },
      okButtonProps: { css: [buttonStyle.size.small, buttonStyle.type.default] },
      onOk() {
        sendEmail(user.EmailAddress);
      },
      onCancel() {},
    });
  };

  return (
    <div css={styles.changePasswordContainer}>
      <HeaderSection headerText="My Password" />
      <p>
        Click the “Reset Password” button to change your password. Once you confirm your request, we
        will send you an email with a link to reset your password. If you do not receive an email,
        please check your spam folder. If you continue to experience problems changing your
        password, please email us at{' '}
        <a href="mailto:membership@apci.org">membership@apci.org</a>.
      </p>
      <p css={styles.text}>
        Email:
        <br />
        {user.EmailAddress}
      </p>
      <StickyFooter>
        <Button size="small" theme="darkOutlined" onClick={submit} css={styles.buttonStyle}>
          Reset Password
        </Button>
      </StickyFooter>
    </div>
  );
};

ChangePasswordForm.propTypes = {};

function mapStateToProps(state) {
  const {
    auth: { userinfo },
  } = state;
  return {
    user: userinfo,
  };
}

export default connect(mapStateToProps)(ChangePasswordForm);
